import { readContract, writeContractAndWait } from "../viem";
import config from "../../config/config";
import MafiaGIManagerAbi from "../../abis/MafiaGIManager.json";

const address = config.giManager;
const abi = MafiaGIManagerAbi;

export const createGIRequest = async (
  account: string,
  target: string,
  assetType: number,
  cityId: number
) => {
  const createRequest = await writeContractAndWait({
    address,
    abi,
    functionName: "createRequest",
    args: [target, assetType, cityId],
    account,
  });
  return createRequest;
};

export const getCreditAmount = async (assetType: number, target: string) => {
  const creditAmount = await readContract({
    address,
    abi,
    functionName: "getCreditAmount",
    args: [assetType, target],
  });
  return creditAmount;
};
